import styled from 'styled-components';

import { ChevronIcon } from '@assets/icons';
import {
  StyledArrowCenterBox,
  StyledArrowTopLeft,
  StyledArrowTopRight,
  StyledDotCenter,
  StyledFlexStatusBoxContainer,
} from '@components/BookingProcessModal/common';
import { StatusBox } from '@components/BookingProcessModal/components/StatusBox';
import { StatusBoxContent } from '@components/BookingProcessModal/components/StatusBoxContent';
import { getClientEvironmentId } from '@lib/utils/clientEnvironment';
import theme from '@styles/theme';

export const SecondStep = () => {
  const statusCheckContent = getStatusCheckContent();
  const confirmAvailableContent = getConfirmAvailableContent();

  return (
    <StyledContainer>
      <StatusBox
        title='Step 2: Status Check'
        headerColor='#fff'
        headerBackground={theme.palette.stroke[4]}
        borderColor={theme.palette.stroke[4]}
        content={statusCheckContent}
        className='position-relative'
      >
        <StyledArrowTopLeft
          arrowRadius={ARROW_RADIUS}
          verticalGapDesktop={VERTICAL_GAP_DESKTOP}
          verticalGapMobile={VERTICAL_GAP_MOBILE}
        >
          <div className='actual-arrow' />
        </StyledArrowTopLeft>
        <StyledArrowTopRight
          arrowRadius={ARROW_RADIUS}
          verticalGapDesktop={VERTICAL_GAP_DESKTOP}
          verticalGapMobile={VERTICAL_GAP_MOBILE}
        >
          <div className='actual-arrow' />
        </StyledArrowTopRight>
        <StyledDotCenter dotSize={DOT_SIZE} dotPadding={DOT_PADDING}>
          <div className='actual-dot' />
        </StyledDotCenter>
      </StatusBox>
      <StyledFlexStatusBoxContainer
        horizontalGapDesktop={HORIZONTAL_GAP_DESKTOP}
        verticalGapDesktop={VERTICAL_GAP_DESKTOP}
        horizontalGapMobile={HORIZONTAL_GAP_MOBILE}
        verticalGapMobile={VERTICAL_GAP_MOBILE}
      >
        <StyledStatusBox
          title='Confirm Available'
          headerBackground={theme.palette.color[14]}
          borderColor={theme.palette.primary[18]}
          content={
            <StatusBoxContent
              content={confirmAvailableContent}
              statusLabel='Avail Confirmed'
              statusColor={theme.palette.stroke[5]}
            />
          }
        >
          <StyledArrowCenterBox
            horizontalGapDesktop={HORIZONTAL_GAP_DESKTOP}
            verticalGapDesktop={VERTICAL_GAP_DESKTOP}
            arrowRadius={ARROW_RADIUS}
            horizontalGapMobile={HORIZONTAL_GAP_MOBILE}
            verticalGapMobile={VERTICAL_GAP_MOBILE}
          >
            <div className='chevron-container'>
              <ChevronIcon direction='down' stroke={theme.palette.stroke[1]} />
            </div>
            <div className='chevron-container right-chevron-container'>
              <ChevronIcon direction='down' stroke={theme.palette.stroke[1]} />
            </div>
          </StyledArrowCenterBox>
        </StyledStatusBox>
        <StyledStatusBox
          title='Deny'
          headerBackground={theme.palette.primary[19]}
          borderColor={theme.palette.stroke[1]}
          content={
            <StatusBoxContent
              content='Denying a Status Check will not negatively impact your profile! Note that you can deny a role even if you’ve previously re-confirmed your availability.'
              statusLabel='Denied'
              statusColor={theme.palette.color[0]}
            />
          }
        />
      </StyledFlexStatusBoxContainer>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  padding: 40px 40px 0px;
  height: 100%;

  @media (max-width: 960px) {
    padding: 20px 20px 24px;
  }
`;

const VERTICAL_GAP_DESKTOP = 52;
const VERTICAL_GAP_MOBILE = 42;

const HORIZONTAL_GAP_DESKTOP = 21;
const HORIZONTAL_GAP_MOBILE = 12;

const ARROW_RADIUS = 8;

const StyledStatusBox = styled(StatusBox)`
  flex: 1;
  position: relative;
`;

const DOT_SIZE = 5;
const DOT_PADDING = 3;

const getStatusCheckContent = () => {
  const clientEvironmentId = getClientEvironmentId();
  // `1` is for AH, `2` is for Everyset
  if (clientEvironmentId === 1 || clientEvironmentId === 2) {
    return "When you receive a 'Status Check', you are being considered for a potential role and need to re-confirm your availability. Casting relies on your response for next steps.";
  }

  // external environment that is not AH

  return (
    <div>
      When you receive a Status Check message, casting may want to move you to
      the next step so be sure to reply asap. Because this is the last step
      before a potential booking,{' '}
      <span className='font-weight-600'>casting relies on your response.</span>
    </div>
  );
};

const getConfirmAvailableContent = () => {
  const clientEvironmentId = getClientEvironmentId();
  // `1` is for AH, `2` is for Everyset
  if (clientEvironmentId === 1 || clientEvironmentId === 2) {
    return "If you're still interested, re-confirm your availability. This is the last status before a potential booking, so please keep casting informed of any possible conflicts.";
  }

  // external environment that is not AH

  return (
    <div>
      If you’re still interested and{' '}
      <span className='font-weight-600'>
        agree to inform casting of any changes,{' '}
      </span>
      re-confirm your availability. Casting uses this re-confirmation to
      finalize the candidate list.
    </div>
  );
};
